export default "https://cdn-static.gokick.com/assets/e21cd8011b9b3a74c4cd288f1b94a870d12ac47c/images/sleep-tangerine.8751d74b530006d7d64194d2bb6c9716.png";